import { render, staticRenderFns } from "./Upload.vue?vue&type=template&id=5e57d17e&scoped=true&"
import script from "./Upload.vue?vue&type=script&lang=js&"
export * from "./Upload.vue?vue&type=script&lang=js&"
import style0 from "./Upload.vue?vue&type=style&index=0&id=5e57d17e&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5e57d17e",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("G:\\jenkinsworkspace\\Aigo.B2CAdmin.Publish\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('5e57d17e')) {
      api.createRecord('5e57d17e', component.options)
    } else {
      api.reload('5e57d17e', component.options)
    }
    module.hot.accept("./Upload.vue?vue&type=template&id=5e57d17e&scoped=true&", function () {
      api.rerender('5e57d17e', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/page/Upload.vue"
export default component.exports